module.exports = __webpack_public_path__ + "static/media/srpt.0650912c.png";